import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Alert, Button, Col, Collapse, Glyphicon, PageHeader, Row, Well } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import DefaultRoutes from '../../routes/DefaultRoutes';
import { InjectedProps } from '../../types';
import { AppointmentTypes } from '../../types/AppointmentType';
import { AppointmentTypeNew } from './AppointmentTypeNew';

interface AppointmentTypeListState {
    open: boolean;
    newItem?: AppointmentTypes;
    sortName: any;
    sortOrder: any;
}

@inject('store')
@observer
export class AppointmentTypeList extends React.Component<{}, AppointmentTypeListState> {
    public get injected() {
        return this.props as InjectedProps;
    }

    public state: AppointmentTypeListState = {
        open: false,
        sortName: 'name',
        sortOrder: 'asc'
    };

    public componentDidMount() {
        const { fetchAppointmentType } = this.injected.store;
        return fetchAppointmentType();
    }

    public onSortChange(sortName: any, sortOrder: any) {
        this.setState({
            sortName,
            sortOrder
        });
    }

    public render() {
        const { newItem } = this.state;
        const options = {
            onRowClick: this.handleRowClick,
            sortName: this.state.sortName,
            sortOrder: this.state.sortOrder,
            onSortChange: this.onSortChange
        };
        const { appointmentTypes } = this.injected.store;

        return (
            <>
                <PageHeader>Schedule Genie Appointment Types</PageHeader>
                <Col className="col-lg-12">
                    {newItem && (
                        <Alert bsStyle="success" onDismiss={this.handleDismissAlert}>
                            Appointment Type "{newItem.name}" was created successfully.
                        </Alert>
                    )}
                    <Row>
                        <Button bsStyle="primary" onClick={this.toggleNewForm}>
                            Create Appointment Type <Glyphicon glyph="plus" />
                        </Button>
                    </Row>
                    <Collapse in={this.state.open}>
                        <Row>
                            <Well>
                                <AppointmentTypeNew handleClose={this.itemAdded} />
                            </Well>
                        </Row>
                    </Collapse>
                    <Row>
                        <BootstrapTable
                            data={appointmentTypes.values}
                            options={options}
                            pagination
                            search
                            striped
                        >
                            <TableHeaderColumn dataField="id" isKey width="80" dataSort>
                                ID
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="name" dataSort>
                                Name
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="slug" dataSort>
                                Slug
                            </TableHeaderColumn>
                        </BootstrapTable>
                    </Row>
                </Col>
            </>
        );
    }

    public handleRowClick = (row: any) => {
        const { router } = this.injected.store;
        router.goTo(DefaultRoutes.AppointmentTypeEdit, { id: row.id }, this.injected.store);
    };

    public toggleNewForm = () => {
        this.setState({ open: !this.state.open });
    };

    public itemAdded = (item: any) => {
        this.setState({ newItem: item });
        this.toggleNewForm();
    };

    public handleDismissAlert = () => {
        this.setState({ newItem: undefined });
    };
}

export default AppointmentTypeList;
